import { render } from "./Settings.vue?vue&type=template&id=6137acf8&scoped=true"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"

import "./Settings.vue?vue&type=style&index=0&id=6137acf8&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6137acf8"],['__file',"src/components/views/project/settings/Settings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6137acf8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6137acf8', __exports__)) {
    api.reload('6137acf8', __exports__)
  }
  
  module.hot.accept("./Settings.vue?vue&type=template&id=6137acf8&scoped=true", () => {
    api.rerender('6137acf8', render)
  })

}


export default __exports__